import { AbilityUse } from './types';

// Auto-generated ability dictionary

interface Ability {
  key: string;
  name: string;
  image_url: string;
}

interface AgentAbilities {
  [agent: string]: Ability[];
}

export const ABILITIES: AgentAbilities = {
  "astra": [
    {
      "key": "cosmicdivide",
      "name": "Cosmic Divide",
      "image_url": "/abilities/astra.cosmicdivide.png"
    },
    {
      "key": "gravitywell",
      "name": "Gravity Well",
      "image_url": "/abilities/astra.gravitywell.png"
    },
    {
      "key": "novapulse",
      "name": "Nova Pulse",
      "image_url": "/abilities/astra.novapulse.png"
    },
    {
      "key": "dissipate",
      "name": "Dissipate",
      "image_url": "/abilities/astra.dissipate.png"
    },
    {
      "key": "stars",
      "name": "Stars",
      "image_url": "/abilities/astra.stars.png"
    }
  ],
  "breach": [
    {
      "key": "rollingthunder",
      "name": "Rolling Thunder",
      "image_url": "/abilities/breach.rollingthunder.png"
    },
    {
      "key": "aftershock",
      "name": "Aftershock",
      "image_url": "/abilities/breach.aftershock.png"
    },
    {
      "key": "flashpoint",
      "name": "Flashpoint",
      "image_url": "/abilities/breach.flashpoint.png"
    },
    {
      "key": "faultline",
      "name": "Fault Line",
      "image_url": "/abilities/breach.faultline.png"
    }
  ],
  "brimstone": [
    {
      "key": "orbitalstrike",
      "name": "Orbital Strike",
      "image_url": "/abilities/brimstone.orbitalstrike.png"
    },
    {
      "key": "stimbeacon",
      "name": "Stim Beacon",
      "image_url": "/abilities/brimstone.stimbeacon.png"
    },
    {
      "key": "incendiary",
      "name": "Incendiary",
      "image_url": "/abilities/brimstone.incendiary.png"
    },
    {
      "key": "skysmoke",
      "name": "Sky Smoke",
      "image_url": "/abilities/brimstone.skysmoke.png"
    }
  ],
  "chamber": [
    {
      "key": "tourdeforce",
      "name": "Tour De Force",
      "image_url": "/abilities/chamber.tourdeforce.png"
    },
    {
      "key": "trademark",
      "name": "Trademark",
      "image_url": "/abilities/chamber.trademark.png"
    },
    {
      "key": "headhunter",
      "name": "Headhunter",
      "image_url": "/abilities/chamber.headhunter.png"
    },
    {
      "key": "rendezvous",
      "name": "Rendezvous",
      "image_url": "/abilities/chamber.rendezvous.png"
    }
  ],
  "clove": [
    {
      "key": "notdeadyet",
      "name": "Not Dead Yet",
      "image_url": "/abilities/clove.notdeadyet.png"
    },
    {
      "key": "pickmeup",
      "name": "Pick Me Up",
      "image_url": "/abilities/clove.pickmeup.png"
    },
    {
      "key": "meddle",
      "name": "Meddle",
      "image_url": "/abilities/clove.meddle.png"
    },
    {
      "key": "ruse",
      "name": "Ruse",
      "image_url": "/abilities/clove.ruse.png"
    }
  ],
  "cypher": [
    {
      "key": "neuraltheft",
      "name": "Neural Theft",
      "image_url": "/abilities/cypher.neuraltheft.png"
    },
    {
      "key": "trapwire",
      "name": "Trapwire",
      "image_url": "/abilities/cypher.trapwire.png"
    },
    {
      "key": "cybercage",
      "name": "Cyber Cage",
      "image_url": "/abilities/cypher.cybercage.png"
    },
    {
      "key": "spycam",
      "name": "Spycam",
      "image_url": "/abilities/cypher.spycam.png"
    }
  ],
  "deadlock": [
    {
      "key": "annihilation",
      "name": "Annihilation",
      "image_url": "/abilities/deadlock.annihilation.png"
    },
    {
      "key": "barriermesh",
      "name": "Barrier Mesh",
      "image_url": "/abilities/deadlock.barriermesh.png"
    },
    {
      "key": "sonicsensor",
      "name": "Sonic Sensor",
      "image_url": "/abilities/deadlock.sonicsensor.png"
    },
    {
      "key": "gravnet",
      "name": "GravNet",
      "image_url": "/abilities/deadlock.gravnet.png"
    }
  ],
  "fade": [
    {
      "key": "nightfall",
      "name": "Nightfall",
      "image_url": "/abilities/fade.nightfall.png"
    },
    {
      "key": "prowler",
      "name": "Prowler",
      "image_url": "/abilities/fade.prowler.png"
    },
    {
      "key": "seize",
      "name": "Seize",
      "image_url": "/abilities/fade.seize.png"
    },
    {
      "key": "haunt",
      "name": "Haunt",
      "image_url": "/abilities/fade.haunt.png"
    }
  ],
  "gekko": [
    {
      "key": "thrash",
      "name": "Thrash",
      "image_url": "/abilities/gekko.thrash.png"
    },
    {
      "key": "moshpit",
      "name": "Mosh Pit",
      "image_url": "/abilities/gekko.moshpit.png"
    },
    {
      "key": "wingman",
      "name": "Wingman",
      "image_url": "/abilities/gekko.wingman.png"
    },
    {
      "key": "dizzy",
      "name": "Dizzy",
      "image_url": "/abilities/gekko.dizzy.png"
    }
  ],
  "harbor": [
    {
      "key": "reckoning",
      "name": "Reckoning",
      "image_url": "/abilities/harbor.reckoning.png"
    },
    {
      "key": "cascade",
      "name": "Cascade",
      "image_url": "/abilities/harbor.cascade.png"
    },
    {
      "key": "cove",
      "name": "Cove",
      "image_url": "/abilities/harbor.cove.png"
    },
    {
      "key": "hightide",
      "name": "High Tide",
      "image_url": "/abilities/harbor.hightide.png"
    }
  ],
  "iso": [
    {
      "key": "killcontract",
      "name": "Kill Contract",
      "image_url": "/abilities/iso.killcontract.png"
    },
    {
      "key": "contingency",
      "name": "Contingency",
      "image_url": "/abilities/iso.contingency.png"
    },
    {
      "key": "undercut",
      "name": "Undercut",
      "image_url": "/abilities/iso.undercut.png"
    },
    {
      "key": "doubletap",
      "name": "Double Tap",
      "image_url": "/abilities/iso.doubletap.png"
    },
  ],
  "jett": [
    {
      "key": "bladestorm",
      "name": "Blade Storm",
      "image_url": "/abilities/jett.bladestorm.png"
    },
    {
      "key": "cloudburst",
      "name": "Cloudburst",
      "image_url": "/abilities/jett.cloudburst.png"
    },
    {
      "key": "updraft",
      "name": "Updraft",
      "image_url": "/abilities/jett.updraft.png"
    },
    {
      "key": "tailwind",
      "name": "Tailwind",
      "image_url": "/abilities/jett.tailwind.png"
    }
  ],
  "kayo": [
    {
      "key": "nullcmd",
      "name": "NULL/cmd",
      "image_url": "/abilities/kayo.nullcmd.png"
    },
    {
      "key": "fragment",
      "name": "FRAG/ment",
      "image_url": "/abilities/kayo.fragment.png"
    },
    {
      "key": "flashdrive",
      "name": "FLASH/drive",
      "image_url": "/abilities/kayo.flashdrive.png"
    },
    {
      "key": "zeropoint",
      "name": "ZERO/point",
      "image_url": "/abilities/kayo.zeropoint.png"
    }
  ],
  "killjoy": [
    {
      "key": "lockdown",
      "name": "Lockdown",
      "image_url": "/abilities/killjoy.lockdown.png"
    },
    {
      "key": "nanoswarm",
      "name": "Nano Swarm",
      "image_url": "/abilities/killjoy.nanoswarm.png"
    },
    {
      "key": "alarmbot",
      "name": "Alarm Bot",
      "image_url": "/abilities/killjoy.alarmbot.png"
    },
    {
      "key": "turret",
      "name": "Turret",
      "image_url": "/abilities/killjoy.turret.png"
    }
  ],
  "neon": [
    {
      "key": "overdrive",
      "name": "Overdrive",
      "image_url": "/abilities/neon.overdrive.png"
    },
    {
      "key": "fastlane",
      "name": "Fast Lane",
      "image_url": "/abilities/neon.fastlane.png"
    },
    {
      "key": "relaybolt",
      "name": "Relay Bolt",
      "image_url": "/abilities/neon.relaybolt.png"
    },
    {
      "key": "highgear",
      "name": "High Gear",
      "image_url": "/abilities/neon.highgear.png"
    }
  ],
  "omen": [
    {
      "key": "fromtheshadows",
      "name": "From The Shadows",
      "image_url": "/abilities/omen.fromtheshadows.png"
    },
    {
      "key": "shroudedstep",
      "name": "Shrouded Step",
      "image_url": "/abilities/omen.shroudedstep.png"
    },
    {
      "key": "paranoia",
      "name": "Paranoia",
      "image_url": "/abilities/omen.paranoia.png"
    },
    {
      "key": "darkcover",
      "name": "Dark Cover",
      "image_url": "/abilities/omen.darkcover.png"
    }
  ],
  "phoenix": [
    {
      "key": "runitback",
      "name": "Run It Back",
      "image_url": "/abilities/phoenix.runitback.png"
    },
    {
      "key": "blaze",
      "name": "Blaze",
      "image_url": "/abilities/phoenix.blaze.png"
    },
    {
      "key": "hothands",
      "name": "Hot Hands",
      "image_url": "/abilities/phoenix.hothands.png"
    },
    {
      "key": "curveball",
      "name": "Curveball",
      "image_url": "/abilities/phoenix.curveball.png"
    }
  ],
  "raze": [
    {
      "key": "showstopper",
      "name": "Showstopper",
      "image_url": "/abilities/raze.showstopper.png"
    },
    {
      "key": "boombot",
      "name": "Boom Bot",
      "image_url": "/abilities/raze.boombot.png"
    },
    {
      "key": "blastpack",
      "name": "Blast Pack",
      "image_url": "/abilities/raze.blastpack.png"
    },
    {
      "key": "paintshells",
      "name": "Paint Shells",
      "image_url": "/abilities/raze.paintshells.png"
    }
  ],
  "reyna": [
    {
      "key": "empress",
      "name": "Empress",
      "image_url": "/abilities/reyna.empress.png"
    },
    {
      "key": "leer",
      "name": "Leer",
      "image_url": "/abilities/reyna.leer.png"
    },
    {
      "key": "devour",
      "name": "Devour",
      "image_url": "/abilities/reyna.devour.png"
    },
    {
      "key": "dismiss",
      "name": "Dismiss",
      "image_url": "/abilities/reyna.dismiss.png"
    }
  ],
  "sage": [
    {
      "key": "resurrection",
      "name": "Resurrection",
      "image_url": "/abilities/sage.resurrection.png"
    },
    {
      "key": "barrierorb",
      "name": "Barrier Orb",
      "image_url": "/abilities/sage.barrierorb.png"
    },
    {
      "key": "sloworb",
      "name": "Slow Orb",
      "image_url": "/abilities/sage.sloworb.png"
    },
    {
      "key": "healingorb",
      "name": "Healing Orb",
      "image_url": "/abilities/sage.healingorb.png"
    }
  ],
  "skye": [
    {
      "key": "seekers",
      "name": "Seekers",
      "image_url": "/abilities/skye.seekers.png"
    },
    {
      "key": "regrowth",
      "name": "Regrowth",
      "image_url": "/abilities/skye.regrowth.png"
    },
    {
      "key": "trailblazer",
      "name": "Trailblazer",
      "image_url": "/abilities/skye.trailblazer.png"
    },
    {
      "key": "guidinglight",
      "name": "Guiding Light",
      "image_url": "/abilities/skye.guidinglight.png"
    }
  ],
  "sova": [
    {
      "key": "huntersfury",
      "name": "Hunter's Fury",
      "image_url": "/abilities/sova.huntersfury.png"
    },
    {
      "key": "owldrone",
      "name": "Owl Drone",
      "image_url": "/abilities/sova.owldrone.png"
    },
    {
      "key": "shockbolt",
      "name": "Shock Bolt",
      "image_url": "/abilities/sova.shockbolt.png"
    },
    {
      "key": "reconbolt",
      "name": "Recon Bolt",
      "image_url": "/abilities/sova.reconbolt.png"
    }
  ],
  'tejo': [
    {
      key: 'armageddon',
      name: 'Armageddon',
      image_url: '/abilities/tejo.armageddon.png'
    },
    {
      key: 'stealthdrone',
      name: 'Stealth Drone',
      image_url: '/abilities/tejo.stealthdrone.png'
    },
    {
      key: 'specialdelivery',
      name: 'Special Delivery',
      image_url: '/abilities/tejo.specialdelivery.png'
    },
    {
      key: 'guidedsalvo',
      name: 'Guided Salvo',
      image_url: '/abilities/tejo.guidedsalvo.png'
    },
  ],
  "viper": [
    {
      "key": "viperspit",
      "name": "Viper's Pit",
      "image_url": "/abilities/viper.viperspit.png"
    },
    {
      "key": "snakebite",
      "name": "Snake Bite",
      "image_url": "/abilities/viper.snakebite.png"
    },
    {
      "key": "poisoncloud",
      "name": "Poison Cloud",
      "image_url": "/abilities/viper.poisoncloud.png"
    },
    {
      "key": "toxicscreen",
      "name": "Toxic Screen",
      "image_url": "/abilities/viper.toxicscreen.png"
    }
  ],
  "vyse": [
    {
      "key": "steelgarden",
      "name": "Steel Garden",
      "image_url": "/abilities/vyse.steelgarden.png"
    },
    {
      "key": "razorvine",
      "name": "Razor Vine",
      "image_url": "/abilities/vyse.razorvine.png"
    },
    {
      "key": "shear",
      "name": "Shear",
      "image_url": "/abilities/vyse.shear.png"
    },
    {
      "key": "arcrose",
      "name": "Arc Rose",
      "image_url": "/abilities/vyse.arcrose.png"
    }
  ],
  "waylay": [
    {
      "key": "convergentpaths",
      "name": "Convergent Paths",
      "image_url": "/abilities/waylay.convergentpaths.png"
    },
    {
      "key": "saturate",
      "name": "Saturate",
      "image_url": "/abilities/waylay.saturate.png"
    },
    {
      "key": "lightspeed",
      "name": "Lightspeed",
      "image_url": "/abilities/waylay.lightspeed.png"
    },
    {
      "key": "refract",
      "name": "Refract",
      "image_url": "/abilities/waylay.refract.png"
    }
  ],
  "yoru": [
    {
      "key": "dimensionaldrift",
      "name": "Dimensional Drift",
      "image_url": "/abilities/yoru.dimensionaldrift.png"
    },
    {
      "key": "fakeout",
      "name": "Fakeout",
      "image_url": "/abilities/yoru.fakeout.png"
    },
    {
      "key": "blindside",
      "name": "Blindside",
      "image_url": "/abilities/yoru.blindside.png"
    },
    {
      "key": "gatecrash",
      "name": "Gatecrash",
      "image_url": "/abilities/yoru.gatecrash.png"
    }
  ]
};

export function processAbilityUsage(frames: any[], playerIndex: number, debug: boolean = false): AbilityUse[] {
  // Special case for Astra - return empty array since ability data is unreliable
  if (frames[0]?.players[playerIndex]?.agent?.toLowerCase() === 'astra') {
    return [];
  }

  if(debug) {
    console.log("Debug ability usage for player", playerIndex);
    console.log("seconds_from_round_start | alive | ability_1 | ability_2 | ability_3 ");
    console.log("------------------------------------------------");
    frames.forEach(frame => {
      const player = frame.players[playerIndex];
      console.log(
        `${frame.seconds_from_round_start.toFixed(2).padStart(8)} | ` +
        `${player.alive.toString().padStart(9)} | ` + 
        `${player.ability_1.toString().padStart(9)} | ` +
        `${player.ability_2.toString().padStart(9)} | ` +
        `${player.ability_3.toString().padStart(9)}`
      );
    });
    console.log("------------------------------------------------");
  }

  // First filter pass - remove dead players
  const aliveFrames = frames.filter((frame) => {
    const currentPlayer = frame.players[playerIndex];
    return currentPlayer.alive;
  });

  // Second filter pass - remove large jumps
  const jumpFilteredFrames = aliveFrames.filter((frame, index) => {
    if (index === 0) return true;

    const currentPlayer = frame.players[playerIndex];
    const prevPlayer = aliveFrames[index - 1].players[playerIndex];

    if (Math.abs(currentPlayer.ability_1 - prevPlayer.ability_1) >= 2 ||
      Math.abs(currentPlayer.ability_2 - prevPlayer.ability_2) >= 2 ||
      Math.abs(currentPlayer.ability_3 - prevPlayer.ability_3) >= 2) {
      return false;
    }

    return true;
  });

  // Third filter pass - remove temporary dips
  const validFrames = jumpFilteredFrames.filter((frame, index) => {
    if (index === 0 || index === jumpFilteredFrames.length - 1) return true;

    const prevPlayer = jumpFilteredFrames[index - 1].players[playerIndex];
    const currentPlayer = frame.players[playerIndex];
    const nextPlayer = jumpFilteredFrames[index + 1].players[playerIndex];

    // Check for temporary dips in abilities
    if ((currentPlayer.ability_1 < prevPlayer.ability_1 && nextPlayer.ability_1 > currentPlayer.ability_1) ||
      (currentPlayer.ability_2 < prevPlayer.ability_2 && nextPlayer.ability_2 > currentPlayer.ability_2) ||
      (currentPlayer.ability_3 < prevPlayer.ability_3 && nextPlayer.ability_3 > currentPlayer.ability_3)) {
      return false;
    }

    return true;
  });

  const uses: AbilityUse[] = [];

  // Now process the filtered frames
  for (let i = 0; i < validFrames.length - 3; i++) {
    const currentFrame = validFrames[i].players[playerIndex];

    const prevPrevFrame = i >= 2 ? validFrames[i - 2].players[playerIndex] : currentFrame;
    const prevFrame = i >= 1 ? validFrames[i - 1].players[playerIndex] : currentFrame;
    const nextFrame = validFrames[i + 1].players[playerIndex];
    const nextNextFrame = validFrames[i + 2].players[playerIndex];
    const nextNextNextFrame = validFrames[i + 3].players[playerIndex];
    const timeSeconds = (validFrames[i].seconds_from_round_start + validFrames[i + 1].seconds_from_round_start) / 2;

    // Early out if time gap between frames is too large (> 6 seconds)
    const timeDiff = validFrames[i + 2].seconds_from_round_start - (i >= 2 ? validFrames[i - 2].seconds_from_round_start : validFrames[i].seconds_from_round_start);
    if (timeDiff > 6) continue;

    // Check ability_1
    if (prevPrevFrame.ability_1 >= currentFrame.ability_1 &&
      prevFrame.ability_1 >= currentFrame.ability_1 &&
      currentFrame.ability_1 === nextFrame.ability_1 + 1 &&
      nextNextFrame.ability_1 <= nextFrame.ability_1 &&
      nextNextNextFrame.ability_1 <= nextFrame.ability_1) {
      uses.push({ type: 'ability_1', timeSeconds });
    }

    // Check ability_2
    if (prevPrevFrame.ability_2 >= currentFrame.ability_2 &&
      prevFrame.ability_2 >= currentFrame.ability_2 &&
      currentFrame.ability_2 === nextFrame.ability_2 + 1 &&
      nextNextFrame.ability_2 <= nextFrame.ability_2 &&
      nextNextNextFrame.ability_2 <= nextFrame.ability_2) {
      uses.push({ type: 'ability_2', timeSeconds });
    }

    // Check ability_3
    if (prevPrevFrame.ability_3 >= currentFrame.ability_3 &&
      prevFrame.ability_3 >= currentFrame.ability_3 &&
      currentFrame.ability_3 === nextFrame.ability_3 + 1 &&
      nextNextFrame.ability_3 <= nextFrame.ability_3 &&
      nextNextNextFrame.ability_3 <= nextFrame.ability_3) {
      uses.push({ type: 'ability_3', timeSeconds });
    }

    // Check ultimate
    // We ignore first two frames since the model for ultimates is unreliable for those frames
    if (i >= 2 &&
      prevPrevFrame.ultimate >= currentFrame.ultimate &&
      prevFrame.ultimate >= currentFrame.ultimate &&
      currentFrame.ultimate === 1 && nextFrame.ultimate === 0 &&
      nextNextFrame.ultimate <= nextFrame.ultimate &&
      nextNextNextFrame.ultimate <= nextFrame.ultimate) {
      uses.push({ type: 'ultimate', timeSeconds });
    }
  }

  return uses;
}
